import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'

import {activationTraceUrl} from '../ahp/activation-trace'
import {useConnectionTraceId} from './use-connection-trace-id'

export function useConnectionTraceUrl(taskId: string | undefined, sessionId?: string): string | undefined {
  const {isBrowser} = useRuntimeEnvironment()
  const taskTraceId = useConnectionTraceId(taskId)
  const sessionTraceId = useConnectionTraceId(sessionId)

  if (
    !isBrowser ||
    !isFeatureEnabled('one_copilot_telemetry_priority_sampling_staff_only') ||
    !isFeatureEnabled('one_copilot_connection_tracing')
  ) {
    return undefined
  }
  return activationTraceUrl(taskTraceId || sessionTraceId)
}
